export default {
  namespaced: true,
  state: {
    sizeLimit: 10, // MB
    files: [],
    isSubmitted: [],
  },
  getters: {
    getFiles: (state) => state.files,
    getSizeLimit: (state) => state.sizeLimit,
    getIsSubmitted: (state) => state.isSubmitted,
  },
  mutations: {
    SET_FILE(state, payload) {
      state.files[payload.index] = payload.value;
    },
    SET_SUBMITTED(state, payload) {
      state.isSubmitted[payload.index] = payload.value;
    },
  },
  actions: {},
};
